"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var DatePicker_1 = tslib_1.__importDefault(require("./DatePicker"));
var FormDatePicker = function (_a) {
    var form = _a.form, field = _a.field, onChange = _a.onChange, onBlur = _a.onBlur, props = tslib_1.__rest(_a, ["form", "field", "onChange", "onBlur"]);
    var handleChange = function (event) {
        form.setFieldTouched(field.name, true, false);
        field.onChange(event);
        if (onChange)
            onChange(event);
    };
    var handleBlur = function (event) {
        if (onBlur)
            onBlur(event);
    };
    return (react_1.default.createElement(DatePicker_1.default, tslib_1.__assign({}, props, { onChange: handleChange, onBlur: handleBlur, name: field.name, value: field.value, error: !!get_1.default(form.touched, field.name) && !!get_1.default(form.errors, field.name), errorMessage: get_1.default(form.errors, field.name) })));
};
exports.default = FormDatePicker;
//# sourceMappingURL=FormDatePicker.js.map